
const awsConfiguration = {
  region: 'ap-northeast-1',
  IdentityPoolId: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID!,
  UserPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID!,
  ClientId: process.env.REACT_APP_COGNITO_CLIENT_ID!,
}

export default awsConfiguration
